import { render, staticRenderFns } from "./huanxin.vue?vue&type=template&id=1e9efc38&scoped=true&"
import script from "./huanxin.vue?vue&type=script&lang=ts&"
export * from "./huanxin.vue?vue&type=script&lang=ts&"
import style0 from "./huanxin.vue?vue&type=style&index=0&id=1e9efc38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9efc38",
  null
  
)

export default component.exports